import DefaultEntityConsult from 'components/form/DefaultEntityConsult'
import { fetchArray } from 'entity'
import Reuniao from 'entity/Reuniao'
import Rodada from 'entity/Rodada'
import React from 'react'

export default function ReuniaoConsulta() {
    const extraFilter = async (reunioes) => {
        let rodadas = await fetchArray(Rodada.getAll())

        for (let i = 0; i < reunioes.length; i++) {
            for (let j = 0; j < rodadas.length; j++) {
                if (rodadas[j].mesas) {
                    for (let k = 0; k < rodadas[j].mesas.length; k++) {
                        if (reunioes[i].mesa.uid === rodadas[j].mesas[k].uid) {
                            reunioes[i].mesa = rodadas[j].mesas[k]
                        }
                    }
                }
            }
        }

        return reunioes
    }

    return (
        <DefaultEntityConsult
            EntityClass={Reuniao}
            titulo={"REUNIÕES"}
            routeForm={'reuniao'}
            updatedValues={Reuniao.updatedValues}
            extraFilter={extraFilter}
        />
    )
}
